const toggleFullResults = () => {
  const fullResults = document.getElementById('full-results-list');
  fullResults.classList.toggle('hidden');
};
document.addEventListener('DOMContentLoaded', function () {
  const viewers = document.querySelectorAll('.section-real-results--wrapper .image-compare');
  viewers.forEach((element) => {
    // debugger;
    let view = new ImageCompare(element, {
      controlColor: '#FFFFFF',
      controlShadow: true,
      addCircle: true,
      addCircleBlur: true,
      showLabels: true,
      labelOptions: {
        before: 'Before',
        after: 'After',
        onHover: false,
      },
      smoothing: false,
      hoverStart: false,
    });
    view.mount();
  });
  const swiper = new Swiper('.section-real-results--wrapper .swiper', {
    allowTouchMove: false,
    slidesPerView: 1,
    navigation: {
      prevEl: '.section-real-results--wrapper .swiper-button-prev',
      nextEl: '.section-real-results--wrapper .swiper-button-next',
    },
    pagination: {
      el: '.section-real-results--wrapper .swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
    },
    on: {
      init: function () {
        const slides = document.querySelectorAll('.section-real-results--wrapper .swiper-slide');
        let maxHeight = 0;
        slides.forEach((slide) => {
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });
        slides.forEach((slide) => {
          slide.style.height = maxHeight + 'px';
        });
      },
    },
  });
  const wrapper = document.querySelector('.section-real-results--wrapper');
  const aside = wrapper.querySelector('.real-result__aside');
  const slider_block = wrapper.querySelector('.slider__block');
  const comparison_slider_img = slider_block.querySelector('img-comparison-slider');
  aside.style.minHeight = comparison_slider_img.offsetHeight + 'px';
});
